import type { ProjectDetail } from '@/stores/project/types';
import classNames from 'classnames';
import styles from '../index.module.less';
import RecentProjectItem from '../RecentProjectItem';

interface RecentProjectListProps {
  activeProjectId?: string;
  className?: string;
  isAnyProjectRenaming: boolean;
  onDeleteClick: (project: ProjectDetail) => void;
  onRenameCancel: () => void;
  onRenameSave: (project: ProjectDetail, name: string) => void;
  onRenameStart: (projectId: string) => void;
  recentProjects: ProjectDetail[];
  renamingProjectId: string | null;
  variant?: 'default' | 'collapsed-panel';
}

function RecentProjectList(props: RecentProjectListProps) {
  const {
    activeProjectId,
    className,
    isAnyProjectRenaming,
    onDeleteClick,
    onRenameCancel,
    onRenameSave,
    onRenameStart,
    recentProjects,
    renamingProjectId,
    variant = 'default',
  } = props;
  const isCollapsedPanel = variant === 'collapsed-panel';

  return (
    <ul
      className={classNames(styles.list, styles['recent-project-list'], {
        [styles['recent-project-list-collapsed-panel']]: isCollapsedPanel,
      }, className)}
    >
      {recentProjects.map(project => (
        <RecentProjectItem
          activeProjectId={activeProjectId}
          isAnyProjectRenaming={isAnyProjectRenaming}
          isRenaming={project.id === renamingProjectId}
          key={project.id}
          project={project}
          onDeleteClick={onDeleteClick}
          onRenameCancel={onRenameCancel}
          onRenameSave={onRenameSave}
          onRenameStart={onRenameStart}
          variant={variant}
        />
      ))}
    </ul>
  );
}

export default RecentProjectList;
